import { gaEvent } from "analytics/analytics";
import { Row, Image } from "antd";
import ImagePlaceholder from "../../../../assets/images/image-placeholder.png";
import * as GA from "constants/analytics";
export default function CategoryCardImages({ product }) {
  return (
    <Row justify="space-between" style={{ marginTop: "0.3rem" }}>
      <Image
        style={{ borderRadius: "4px" }}
        alt="product name"
        width={"31%"}
        preview={false}
        src={
          product && product[0]?.product_images[0]?.directus_files_id
            ? `${process.env.REACT_APP_CLOUDINARY}/b_rgb:f2f2f2,c_pad,h_60,q_100,w_70/${
                product && product[0]?.product_images[0]?.directus_files_id
              }`
            : ImagePlaceholder
        }
        fallback={
          product && product[0]?.product_images[0]?.directus_files_id
            ? `${process.env.REACT_APP_DIRECTUS}assets/${
                product && product[0]?.product_images[0]?.directus_files_id
              }?transforms=[["resize",{"width":70,"height":60,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`
            : ImagePlaceholder
        }
        onFocus={() => {
          gaEvent(
            GA.EVENT.HOVER,
            GA.CATEGORY.MASTER_CATALOGUE,
            GA.DESCRIPTION.EACH_CATEGORY_CARD_FIRST_IMAGE
          );
        }}
        onClick={() => {
          gaEvent(
            GA.EVENT.CLICK,
            GA.CATEGORY.MASTER_CATALOGUE,
            GA.DESCRIPTION.EACH_CATEGORY_CARD_FIRST_IMAGE
          );
        }}
      />

      <Image
        alt="product name"
        src={
          product && product[1]?.product_images[0]?.directus_files_id
            ? `${process.env.REACT_APP_CLOUDINARY}/b_rgb:f2f2f2,c_pad,h_60,q_100,w_70/${
                product && product[1]?.product_images[0]?.directus_files_id
              }`
            : ImagePlaceholder
        }
        style={{ borderRadius: "4px" }}
        width={"31%"}
        preview={false}
        onFocus={() => {
          gaEvent(
            GA.EVENT.HOVER,
            GA.CATEGORY.MASTER_CATALOGUE,
            GA.DESCRIPTION.EACH_CATEGORY_CARD_SECOND_IMAGE
          );
        }}
        onClick={() => {
          gaEvent(
            GA.EVENT.CLICK,
            GA.CATEGORY.MASTER_CATALOGUE,
            GA.DESCRIPTION.EACH_CATEGORY_CARD_SECOND_IMAGE
          );
        }}
        fallback={
          product && product[1]?.product_images[0]?.directus_files_id
            ? `${process.env.REACT_APP_DIRECTUS}assets/${
                product && product[1]?.product_images[0]?.directus_files_id
              }?transforms=[["resize",{"width":70,"height":60,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`
            : ImagePlaceholder
        }
      />

      <Image
        style={{ borderRadius: "4px" }}
        //  style={{backgroundPosition:'centre centre',backgroundSize:'cover',backgroundRepeat:"no-repeat"}}
        alt="product name"
        width={"31%"}
        preview={false}
        src={
          product && product[2]?.product_images[0]?.directus_files_id
            ? `${process.env.REACT_APP_CLOUDINARY}/b_rgb:f2f2f2,c_pad,h_60,q_100,w_70/${
                product && product[2]?.product_images[0]?.directus_files_id
              }`
            : ImagePlaceholder
        }
        fallback={
          product && product[2]?.product_images[0]?.directus_files_id
            ? `${process.env.REACT_APP_DIRECTUS}assets/${
                product && product[2]?.product_images[0]?.directus_files_id
              }?transforms=[["resize",{"width":70,"height":60,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`
            : ImagePlaceholder
        }
        onFocus={() => {
          gaEvent(
            GA.EVENT.HOVER,
            GA.CATEGORY.MASTER_CATALOGUE,
            GA.DESCRIPTION.EACH_CATEGORY_CARD_THIRD_IMAGE
          );
        }}
        onClick={() => {
          gaEvent(
            GA.EVENT.CLICK,
            GA.CATEGORY.MASTER_CATALOGUE,
            GA.DESCRIPTION.EACH_CATEGORY_CARD_THIRD_IMAGE
          );
        }}
      />
    </Row>
  );
}
